var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
import { plainToInstance } from 'class-transformer';
import { Integration } from 'models';
var IntegrationConfig = /** @class */ (function (_super) {
    __extends(IntegrationConfig, _super);
    function IntegrationConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IntegrationConfig.prototype.getId = function () {
        return Number(this.id);
    };
    IntegrationConfig.prototype.getIntegration = function () {
        return plainToInstance(Integration, this.integration);
    };
    IntegrationConfig.prototype.getApiKey = function () {
        return this.api_key;
    };
    IntegrationConfig.prototype.getEnabled = function () {
        return Boolean(this.enabled);
    };
    return IntegrationConfig;
}(Model));
export default IntegrationConfig;
